(function(){
  const MEMBER_PROXY_PATH='/apps/retrocade-member';

  function formatPoints(value){return Number(value||0).toLocaleString();}

  function applyRewardValues(root,{balance=0,dailyEarned=0,dailyCap=500}={}){
    const card=root.querySelector('[data-retrocade-member-card]');
    if(!card)return;
    const rewardStatus=card.querySelector('[data-member-reward-status]');
    const rewardDetail=card.querySelector('[data-member-reward-detail]');
    if(rewardStatus)rewardStatus.textContent=`${formatPoints(balance)} reward points`;
    if(rewardDetail)rewardDetail.textContent=`10 points per active minute · +25 objective bonus · ${formatPoints(dailyEarned)} / ${formatPoints(dailyCap)} earned today · Redeem Shop redemption coming soon.`;
  }

  async function verifyMember(root){
    const card=root.querySelector('[data-retrocade-member-card]');
    if(!card||card.dataset.memberVerificationReady==='true')return;
    card.dataset.memberVerificationReady='true';

    try{
      const response=await fetch(MEMBER_PROXY_PATH,{method:'GET',credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'}});
      const payload=await response.json().catch(()=>null);
      if(!response.ok||!payload||payload.ok!==true||payload.verified!==true)return;

      const memberLabel=card.querySelector('[data-member-label]');
      const memberCopy=card.querySelector('[data-member-copy]');
      const leaderboardStatus=root.querySelector('[data-lb-player-status]');

      if(payload.authenticated&&payload.memberType==='retrocade_member'){
        const balance=Number(payload.rewards?.balance||0);
        const daily=Number(payload.rewards?.dailyEarned||0);
        const cap=Number(payload.rewards?.dailyEarnCap||500);
        card.classList.remove('is-guest');
        card.classList.add('is-member','is-verified');
        if(memberLabel)memberLabel.textContent='Verified Retrocade Member';
        if(memberCopy)memberCopy.textContent="Play online while signed in to earn Reward Points. Your game score is only for leaderboard ranking.";
        applyRewardValues(root,{balance,dailyEarned:daily,dailyCap:cap});
        if(leaderboardStatus)leaderboardStatus.textContent='Verified Retrocade Member · reward account connected';
      }else{
        card.classList.remove('is-member','is-verified');
        card.classList.add('is-guest');
        if(memberLabel)memberLabel.textContent='Guest Player';
        if(memberCopy)memberCopy.textContent='Guest scores count on the leaderboard, but Reward Points are only earned by signed-in Retrocade Members.';
        const rewardStatus=card.querySelector('[data-member-reward-status]');
        const rewardDetail=card.querySelector('[data-member-reward-detail]');
        if(rewardStatus)rewardStatus.textContent='Sign-in required';
        if(rewardDetail)rewardDetail.textContent='Sign in before launching a game to earn Reward Points and use the Redeem Shop.';
        if(leaderboardStatus)leaderboardStatus.textContent='Guest Player · scores stay with this browser';
      }
    }catch(error){
      // Keep the Liquid-rendered fallback state when the app proxy is not configured or temporarily unavailable.
    }
  }

  function init(scope){
    const roots=(scope.matches&&scope.matches('[data-online-arcade]'))?[scope]:[...scope.querySelectorAll('[data-online-arcade]')];
    roots.forEach(verifyMember);
  }

  window.addEventListener('gizmos:reward-updated',event=>{
    const detail=event.detail||{};
    document.querySelectorAll('[data-online-arcade]').forEach(root=>applyRewardValues(root,{
      balance:Number(detail.balance||0),
      dailyEarned:Number(detail.dailyEarned||0),
      dailyCap:Number(detail.dailyCap||500),
    }));
  });

  document.addEventListener('DOMContentLoaded',()=>init(document));
  document.addEventListener('shopify:section:load',event=>init(event.target));
})();